// https://refine.dev/blog/material-ui-autocomplete-component/
// import { styled } from '@mui/material/styles';
import * as React from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import Paper from '@mui/material/Paper';
import { sidebarwith } from './Const';
import { bgColors } from '../../utils/bgColor';

const ComboBox =(props) =>{
  const {options,label,...otherProps} = props
  return (
    // <ThemeProvider theme={theme}>

    <Autocomplete
      size= 'small'
      {...otherProps}
      disablePortal
      id="combo_box"
      options={options}
      PaperComponent={({ children }) => (
        <Paper style={{ 
          background: bgColors.default_backgroun_grey,
          color:bgColors.grey_900        
        }}>{children}</Paper>
      )}
      sx={{ width: sidebarwith,
        // padding:'1rem',
        // border: `1px  ${bgColors.font_blue}`
        // '& + .MuiAutocomplete-popper .MuiAutocomplete-option': {          
        //   backgroundColor: 'red'
        // }
      
      }}
      renderInput={(params) => 
      <TextField 
        fullWidth
        // variant="outlined"
        sx={{ backgroundColor: `${bgColors['gm2-grey-2=300']} !important`,
        // border: `1px solid ${bgColors.font_blue}`
            
          }}
   
        {...params} label={label} />}

    />
  );
}

export default ComboBox

